const translation = {
  nav: {
    home: 'Home',
    about: 'About',
    projects: 'Projects',
    contact: 'Contact',
  },
  hero: {
    title: 'Creating extraordinary',
    titleLine2: 'spaces for living',
    description: 'We transform visions into reality through innovative interior design, precision construction, and bespoke furniture craftsmanship.',
    cta: 'GET IN TOUCH',
  },
  services: {
    intro: {
      title: 'The Interior Makers at GPsolutions',
      description1: 'We create extraordinary worlds of experience for residential and commercial spaces. Our expertise spans Interior Design, Construction Solutions, and Custom Furniture sectors.',
      description2: 'With years of professional experience, we\'ve established ourselves as a company characterized by innovation, precision, and unwavering commitment to excellence.',
      imageAlt: 'Our Team',
    },
    title: 'Our Services',
    subtitle: 'Comprehensive solutions tailored to bring your vision to life',
    list: {
      interiorDesign: {
        title: 'Interior Design',
        description: 'Comprehensive design services from concept to completion, creating spaces that inspire and function beautifully.',
      },
      construction: {
        title: 'Construction Works',
        description: 'Expert construction services delivering exceptional quality and precision in every project we undertake.',
      },
      furniture: {
        title: 'Custom Furniture',
        description: 'Bespoke furniture pieces crafted with meticulous attention to detail, tailored to your unique vision.',
      },
      cnc: {
        title: 'CNC Milling',
        description: 'Our production facility is equipped with the advanced HyperCut Nesting AMO 2030 machine. We provide precision CNC milling services for our own projects and offer professional milling services to external customers.',
      },
    },
    learnMore: 'LEARN MORE',
    details: {
      interiorDesign: 'Our interior design services encompass every aspect of creating beautiful, functional spaces. From initial concept development to final styling, we work closely with you to understand your vision and bring it to life. Our team of experienced designers combines creativity with practical expertise to deliver spaces that not only look stunning but also enhance your daily life. We handle space planning, color consultation, material selection, furniture sourcing, lighting design, and complete project management. Whether you\'re renovating a single room or designing an entire home or commercial space, we ensure every detail is perfect.',
      construction: 'Our construction services are built on a foundation of quality craftsmanship and attention to detail. We manage all aspects of construction projects, from structural work to finishing touches. Our experienced team works with precision and care, using premium materials and proven techniques to deliver exceptional results. We coordinate all trades, manage timelines, and ensure that every element meets our high standards. From renovations to new builds, we bring technical expertise and dedication to every project, ensuring smooth execution and outstanding quality.',
      furniture: 'Our custom furniture service offers truly bespoke pieces designed and crafted specifically for your space. We work with you from initial design concepts through to final installation, creating furniture that perfectly matches your style and functional needs. Our skilled craftsmen use premium materials and traditional techniques combined with modern technology to produce furniture of exceptional quality. Each piece is made to measure, ensuring perfect fit and finish. From wardrobes and kitchen cabinets to dining tables and storage solutions, we create furniture that becomes a lasting part of your home.',
      cnc: 'Our state-of-the-art CNC milling facility features the advanced HyperCut Nesting AMO 2030 machine, enabling us to deliver precision manufacturing services for complex projects. We offer professional CNC milling for both our own custom furniture projects and external clients. Our capabilities include intricate pattern cutting, precise component manufacturing, decorative panels, architectural elements, and custom signage. With computer-controlled precision, we can execute complex designs with accuracy measured in fractions of millimeters. We work with various materials including wood, MDF, plywood, and composites, providing unlimited design possibilities for your projects.',
    },
    featured: {
      label: 'FEATURED PROJECT',
      title: 'Redefining modern',
      titleLine2: 'living spaces',
      description: 'Our latest residential project showcases the perfect harmony between functionality and aesthetic excellence. Every detail has been carefully considered to create a space that not only looks exceptional but enhances daily living.',
      cta: 'VIEW PROJECT',
    },
    stats: {
      projects: 'PROJECTS COMPLETED',
      years: 'YEARS EXPERIENCE',
      satisfaction: 'CLIENT SATISFACTION',
    },
    cta: {
      title: 'Ready to transform',
      titleLine2: 'your space?',
      description: 'Let\'s discuss how we can bring your vision to life with our expertise in design, construction, and craftsmanship.',
      button: 'START YOUR PROJECT',
    },
  },
  footer: {
    description: 'Creating extraordinary spaces through innovative design and exceptional craftsmanship.',
    services: {
      title: 'SERVICES',
      interiorDesign: 'Interior Design',
      construction: 'Construction Works',
      furniture: 'Custom Furniture',
      cnc: 'CNC Milling',
    },
    company: {
      title: 'COMPANY',
      about: 'About Us',
      projects: 'Projects',
      contact: 'Contact',
    },
    contact: {
      title: 'CONTACT',
    },
    copyright: '© 2025 GPsolutions. All rights reserved.',
    poweredBy: 'Website Builder',
  },
  about: {
    title: 'About Us',
    intro1: 'GPsolutions is a leading interior design and construction company dedicated to creating exceptional spaces that inspire and delight. With years of experience in the industry, we have established ourselves as a trusted partner for residential and commercial projects.',
    intro2: 'Our team of talented designers and craftsmen work closely with clients to bring their vision to life. From initial concept to final execution, we ensure every detail is perfect and every expectation is exceeded.',
    servicesTitle: 'Our Services',
    services: {
      interiorDesign: {
        title: 'Interior design',
        description: 'Complete interior design solutions for homes and businesses, including space planning, color consultation, and furniture selection.',
      },
      construction: {
        title: 'Construction works',
        description: 'Professional construction services with attention to detail, quality materials, and expert craftsmanship.',
      },
      furniture: {
        title: 'Custom made furniture',
        description: 'Bespoke furniture design and manufacturing tailored to your specific needs and style preferences.',
      },
      cnc: {
        title: 'CNC Milling',
        description: 'Our production facility is equipped with the advanced HyperCut Nesting AMO 2030 machine, providing precision CNC milling services for our own projects and offering professional milling services to external customers.',
      },
    },
    whyChooseTitle: 'Why Choose Us',
    whyChoose: {
      item1: 'Experienced team of designers and craftsmen',
      item2: 'Commitment to quality and attention to detail',
      item3: 'Personalized service tailored to your needs',
      item4: 'Competitive pricing and transparent communication',
      item5: 'On-time project delivery and professional execution',
    },
    cta: {
      title: 'Ready to Start Your Project?',
      description: 'Contact us today to discuss your interior design and construction needs.',
      button: 'Get in Touch',
    },
  },
  projects: {
    title: 'Our Projects',
    subtitle: 'Explore our portfolio of completed projects showcasing our expertise in interior design, construction, and custom furniture manufacturing.',
    viewProject: 'View Project',
    photos: 'Photos',
    location: 'Location',
    year: 'Year',
    designer: 'Designer',
    cta: {
      title: 'Ready to Start Your Project?',
      description: 'Let\'s bring your vision to life. Contact us today to discuss your interior design and construction needs.',
      button: 'START YOUR PROJECT',
    },
  },
  contact: {
    title: 'Contact Us',
    subtitle: 'Get in touch with us for your interior design and construction needs',
    getInTouch: 'Get In Touch',
    address: {
      title: 'Address',
    },
    email: {
      title: 'Email',
    },
    phone: {
      title: 'Phone',
    },
    workingHours: {
      title: 'Working Hours',
      days: 'Monday - Friday',
      hours: '08:00 - 16:00',
    },
    followUs: 'Follow Us',
    form: {
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      subject: 'Subject',
      message: 'Message',
      characters: 'characters',
      required: '*',
      submit: 'Send Message',
      sending: 'Sending...',
      success: 'Thank you for your message! We\'ll get back to you soon.',
      error: 'Something went wrong. Please try again later.',
    },
  },
  notFound: {
    title: 'This page has not been generated',
    description: 'Tell me more about this page, so I can generate it',
  },
};

export default translation;
